import _ from "lodash";
import DashboardConstants from "@/store/constants/dashboardRecords";

export default {
  name: "CustomInput",
  props: [
    'data', 'attr', 'parentAttr'
  ],
  data() {
    return {
    };
  },
  methods: {
  },
  computed: {
    getStatusEditable() {
      return this.$store.getters[DashboardConstants.GETTERS.getStatusEditable];
    },
    focus() {
      return _.get(this.data.item, ['isFocus', this.attr].join("."));
    },
    styleCondition() {
      return _.get(this.data.item, ['style', this.attr, "condition"].join("."));
    },
    stylePrevious() {
      return _.get(this.data.item, ['style', this.attr, "previous"].join("."));
    },
    styleLastest() {
      return _.get(this.data.item, ['style', this.attr, "lastest"].join("."));
    },
    dataPrevious() {
      return _.get(this.data.item, ['previousItem', this.attr].join("."));
    },
    shouldShowPrevious() {
      const previous = this.dataPrevious;
      if (previous === null || previous === undefined || previous === "" || previous === "-") {
        return false;
      }
      return true;
    },
    dataLastest() {
      return _.get(this.data.item, this.attr);
    },
    nameElement() {
      return this.parentAttr + "-" + this.attr;
    }
  }
};
